import { render, staticRenderFns } from "./Show-doenca.vue?vue&type=template&id=422b77cf&scoped=true&"
import script from "./Show-doenca.vue?vue&type=script&lang=js&"
export * from "./Show-doenca.vue?vue&type=script&lang=js&"
import style0 from "./Show-doenca.vue?vue&type=style&index=0&id=422b77cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b77cf",
  null
  
)

export default component.exports